enum BankAccountConfirmationStatusEnum {
    Approved = 'APPROVED',
    Legacy = 'LEGACY',
    Pending = 'PENDING',
}

export default BankAccountConfirmationStatusEnum;